import { Klass, u_ } from "@pressmedia/webappbase";

export default {
	wysiwyg: {
		boxClass: "wysiwyg-box",
		pluginConfig: {
			CDNroot: "https://cdnjs.cloudflare.com/ajax/libs/quill",
			version: "1.3.6"
		},
		
		/**
		 * inpType: wysiwyg の項目のキー一覧を取得
		 * @param {Object} dataParams
		 * @returns {Array}
		 */
		_getWysiwygParams(dataParams) {
			const params = [];
			u_.isObject(dataParams) && Object.keys(dataParams).forEach(pk => {
				const pi = dataParams[pk];
				if( u_.isObject(pi) && pi.inpType === "wysiwyg") {
					params.push(pk);
				}
			});
			return params;
		},
		
		/**
		 * wysiwyg用スタイルシートの読み込み
		 * @returns {Promise}
		 */
		async importPluginStyleSheet(app, doc) {
			!doc && (doc = document);
			
			const uri = `${this.pluginConfig.CDNroot}/${this.pluginConfig.version}/quill.`;
			
			// 別のテーマも含めて、既に読み込まれていないかチェック
			const docKey = (doc === document) ? "global" : doc.title;
			const imported = app._imports[docKey];
			if( docKey &&
					u_.isObject(imported) &&
					u_.isObject(imported.stylesheet) &&
					Object.keys(imported.stylesheet).join(" ").indexOf(uri) >= 0
			) {
				// 読み込み済みの場合は終了
				return true;
			}
			
			await new Promise((resolve, reject) => app.require(`${uri}core`, {
				doc: doc,
				type: "stylesheet",
				success: resolve,
				error: reject
			}));
			
			return true;
		},
		
		/**
		 * wysiwyg用の設定を行う
		 * ※呼び出しの際は .call(this) を使用すること
		 * @returns this
		 */
		ready() {
			if( !( this instanceof Klass("TyrellModule") ) ) {
				throw new TypeError("caller must be TyrellModule");
			}
			
			this.wysiwygParams = this.wysiwyg._getWysiwygParams(this.config.dataParams);
			this.wysiwygParams.has = !!this.wysiwygParams.length;
			return this;
		},
		
		/**
		 * wysiwyg用データ中の{fileDir}をconfig.fileDirの値に置き換える
		 * ※呼び出しの際は .call(this) を使用すること
		 * @param {Object} item
		 * @returns this
		 */
		replaceFileDir(item) {
			if( !( this instanceof Klass("TyrellModule") ) ) {
				throw new TypeError("caller must be TyrellModule");
			}
			
			if( !u_.isObject(item) ) {
				throw new TypeError("arguments[0] must be object.");
			}
			
			if(this.wysiwygParams.has) {
				const nocacheStr =  ( new Date() ).valueOf();
				this.wysiwygParams.forEach(pk => {
					if( u_.hasProperty(item, pk) ) {
						item[pk] = this.wysiwyg._replaceFileDirForHtml.call(this, item[pk], nocacheStr);
					}
					
					const k = `${pk}_delta`;
					if( u_.hasProperty(item, k) ) {
						item[k] = this.wysiwyg._replaceFileDirForDelta.call(this, item[k], nocacheStr);
						!item[k] && (delete item[k]);
					}
				});
			}
			
			return this;
		},
		
		/**
		 * {fileDir}の置換処理（html用）
		 * ※呼び出しの際は .call(this) を使用すること
		 */
		_replaceFileDirForHtml(str, nocacheStr) {
			if( !str || !u_.isString(str) ) {
				return "";
			}
			
			const qs = !nocacheStr ? "" : `?_=${nocacheStr}`;
			
			str = str.replace(
				/<img ([^>])*src\s*=\s*"\{fileDir\}([^"]*)/g,
				`<img $1src="${this.config.fileDir}$2${qs}`
			);
			
			str = str.replace(/"\{fileDir\}/g, `"${this.config.fileDir}`);
			
			return str;
		},
		
		/**
		 * {fileDir}の置換処理（delta用）
		 * ※呼び出しの際は .call(this) を使用すること
		 */
		_replaceFileDirForDelta: function _replaceFileDirForDelta(delta, nocacheStr) {
			if( !u_.isString(delta) || !(/^\{[\S\s]*\}$/).test(delta) ) {
				return "";
			}
			
//				delta = JSON.parse(delta);
//				u_.mapRecursive(delta, function(v, k) {
//					if( (k === "image" || k === "link") && (/^\{fileDir\}/).test(v) ) {
//						v = v.replace(/^\{fileDir\}/, this.config.fileDir);
//						(k === "image") && (v += `?_=${( new Date() ).valueOf()}`);
//						return v;
//					}
//				}, this);
//				delta = JSON.stringify(delta);
			
			const qs = !nocacheStr ? "" : `?_=${nocacheStr}`;
			delta = delta.replace(
				/"image":"\{fileDir\}([^"]*)/g,
				`"image":"${this.config.fileDir}$1${qs}`
			);
			delta = delta.replace(/"\{fileDir\}/g, `"${this.config.fileDir}`);
			
			return delta;
		}
	}
};
